<template>
<div class="row" v-loading="loading">
  <div class="col-md-12">
    <card :title="title" v-if="modelSchema">
      <remote-select
        v-model="model.event"
        select-class="select-success"
        choice-label-key="name"
        :label="'Event' | translate"
        :placeholder="'Select event' | translate"
        api-url="expostat/event/"
      />

      <remote-select
        v-model="model.server"
        :select-class="rforumServerAvailable ? 'select-success' : 'select-danger'"
        choice-label-key="description"
        :label="'Server' | translate"
        :placeholder="'Select server' | translate"
        @input="updateServer"
        api-url="expostat/server/"
      />


      <remote-select
        v-if="rforumServerAvailable"
        v-model="model.name"
        :select-class="rforumServerAvailable ? 'select-success' : 'select-danger'"
        choice-value="dbNameWithoutPrefix"
        choice-label-key="name"
        :label="'Database' | translate"
        :placeholder="'Select database' | translate"
        @input="updateServer(model.server)"
        :api-url="`${serverInfo.host}/api/rforum-settings/database/`"
      />
      <fg-input v-else :error="errorMessages.name" :max-length="modelSchema.name.maxLength" :required="modelSchema.name.required" v-model="model.name" placeholder="denis_database" :label="'Name' | translate"/>

      <remote-select
        v-if="rforumServerAvailable && model.name"
        v-model="model.exhib"
        :select-class="rforumServerAvailable ? 'select-success' : 'select-danger'"
        choice-value="exhib"
        choice-label-key="name"
        :label="'Exhib' | translate"
        :placeholder="'Select RussCom Forum exhibition' | translate"
        :api-url="`${serverInfo.host}/api/rforum/exhibition/?db=${model.name}`"
      />
      <fg-input v-else :error="errorMessages.exhib" :max-length="modelSchema.exhib.maxLength" :required="modelSchema.exhib.required" v-model="model.exhib" placeholder="1" :label="'Exhib' | translate"/>

      <print-terminal-editor v-model="model.options.pterms"/>

      <p-button type="info" round @click="save">
        <translate key="add" v-if="!isNew">Save</translate>
        <translate key="save" v-else>Add</translate>
      </p-button>
      <p-button type="info" round @click="saveAndClose">
        <translate key="add" v-if="!isNew">Save and close</translate>
        <translate key="save" v-else>Add and close</translate>
      </p-button>

    </card> <!-- end card -->
  </div> <!--  end col-md-6  -->
</div>
</template>

<script>
  import _ from 'lodash'

  import RemoteSelect from '../../Components/RemoteSelect'
  import PrintTerminalEditor from '../Servers/Components/PrintTerminalEditor'

  export default {
    breadcrumb () {
      return {
        label: this.title,
        parent: {
          name: 'manage-databases'
        }
      }
    },
    components: {
      RemoteSelect,
      PrintTerminalEditor,
    },
    props: {
      baseApi: {
        type: String,
        description: 'Remote API base URL',
        default: () => 'expostat/database/'
      }
    },
    name: 'DatabaseForm',
    beforeRouteEnter: (to, from, next) => {
      next(vm => {
        if (to.params.id) {
          vm.loadRecord(to.params.id)
        }
      })
    },
    beforeRouteUpdate: (to, from, next) => {
      next(vm => {
        debugger
        if (to.params.id) {
          vm.loadRecord(to.params.id)
        }
      })
    },
    computed: {
      title () {
        if (this.isNew) {
          return this.$gettext('Add database')
        } else {
          return this.$gettext('Edit database')
        }
      },
      isNew () {
        return this.model.id === null
      },
    },
    created () {
      this.getSchema()

    },
    mounted () {
      if (this.$route.params.id && !this.model.id) {
        this.loadRecord(this.$route.params.id)
      }
    },
    data () {
      return {
        schemaJson: null,
        loading: false,
        errorMessages: {},
        serverInfo: null,

        rforumServerAvailable: false,

        modelSchema: null,
        model: {
          id: null,
          name: null,
          exhib: null,
          event: null,
          server: null,
          options: {
            pterms: []
          }
        }
      }
    },
    methods: {
      async updateServer(serverId) {
        this.rforumServerAvailable = false
        try {
          const response = await this.axios.get(`expostat/server/${serverId}/`)
          this.serverInfo = response.data
          this.updateRForumServerAvailable()
        } catch (e) {
          this.serverInfo = null
          this.rforumServerAvailable = false
          console.log(`Не удалось загрузить информацию о сервере ${serverId}`, e)
        }
      },
      async updateRForumServerAvailable() {
        try {
          const response = await this.axios.get(`${this.serverInfo.host}/api/`)
          if (response.status === 200) {
            this.rforumServerAvailable = true
          } else {
            this.rforumServerAvailable = false
          }
        } catch (e) {
          console.warn(`Сервер RussCom Forum ${this.serverInfo.host} недоступен`, e)
          this.rforumServerAvailable = false
        }
      },
      updateModel (model) {
        this.model = model
        if (model.options === null) {
          model.options = {
            pterms: []
          }
        }
      },
      prepareModelToSave() {
        if (this.$refs.schemaEditor) {
          this.$refs.schemaEditor.getSchema()
        }
        return _.cloneDeep(this.model)
      },
      async loadRecord (id) {
        this.loading = true
        const result = await this.$http.get(`${this.$props.baseApi}${id}/`)
        this.updateServer(result.data.server)
        this.updateModel(result.data)
        this.loading = false
        return result.data
      },
      async getSchema () {
        let url = this.$props.baseApi
        const result = await this.$http.options(url)
        this.schema = result.data
        this.modelSchema = this.schema.actions.POST
      },
      async save () {
        this.loading = true
        const modelToSave = this.prepareModelToSave()
        const request = this.isNew ? this.$http.post(this.$props.baseApi, modelToSave) : this.$http.put(`${this.$props.baseApi}${this.model.id}/`, modelToSave)
        try {
          const result = await request

          // Заменяем ссылку
          this.$router.replace({name: 'manage-database-edit', params: {id: result.data.id}})
          this.updateModel(result.data)
          this.loading = false
          this.errorMessages = {}
          return true
        } catch (error) {
          this.loading = false
          this.errorMessages = _.mapValues(error.response.data, x => x instanceof Array ? x.join(', ') : x)
          return false
        }
      },
      async saveAndClose () {
        if (await this.save()) {
          this.$router.go(-1)
        }
      }
    }
  }
</script>

<style scoped>

</style>
